import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {TextInputComponent} from "../../../common/text-input/text-input.component";

@Component({
  selector: 'app-driver-age',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    TextInputComponent
  ],
  templateUrl: './driver-age.component.html',
  styleUrl: './driver-age.component.css'
})
export class DriverAgeComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  age: number | null = null;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.age)
        this.age = this.claimService.claimReport().age;
    })
  }

  private evaluateShowError() {
    this.showError = this.age === null;
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({age: this.age});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['driver-age']);
      });
    }
  }
}
